module.exports = __webpack_public_path__ + "static/img/region.17a1e73d.png";